import type { EmbarcacaoDimensoesField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const DIMENSOES_PRINCIPAIS_ID = "dimensoes-principais";
export const DIMENSOES_PRINCIPAIS_TITLE = "Dimensões Principais";
export const DIMENSOES_PRINCIPAIS_TEST_ID = "embarcacao-dimensoes-principais";
export const DIMENSOES_PRINCIPAIS_LOADING_MESSAGE =
  "Carregando as Dimensões Principais da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const DIMENSOES_PRINCIPAIS_EMPTY_STATE = {
  title: "Nenhuma informação de Dimensões Principais disponível",
  description:
    "Assim que houver dados dimensionais para esta embarcação, eles aparecerão nesta seção.",
};

/**
 * Os 24 campos da seção, na ordem do AC2 — os 21 campos dimensionais e as três
 * datas de conjunto.
 *
 * A ordem vem dos agrupamentos da planilha de origem (Dimensões Principais,
 * Cargo Deck e Plano de docagem), mas os agrupamentos não aparecem na tela: por
 * decisão do PO a seção é uma lista contínua, como a Base Técnica (AC2). As
 * datas de cada conjunto entram como campos comuns, cada uma com o seu rótulo,
 * de modo que nenhuma seja lida como a data de outro conjunto (RN006/AC3).
 *
 * O grid distribui os campos em duas colunas, preenchendo a linha da esquerda
 * para a direita; nenhum campo precisa abrir linha nesta seção.
 */
export const DIMENSOES_PRINCIPAIS_FIELDS: readonly DetailFieldDefinition<EmbarcacaoDimensoesField>[] =
  [
    { key: "comprimentoTotal", label: "Comprimento total (m)" },
    { key: "comprimentoEntrePerpendiculares", label: "Comprimento entre perpendiculares (m)" },
    { key: "caladoMax", label: "Calado máx (m)" },
    { key: "caladoDocagem", label: "Calado Docagem (m)" },
    { key: "bocaMoldada", label: "Boca moldada (m)" },
    { key: "arqueacaoBruta", label: "Arqueação bruta" },
    { key: "arqueacaoLiquida", label: "Arqueação líquida" },
    { key: "tonelagemPorteBruto", label: "Tonelagem porte bruto (T)" },
    {
      key: "atualizacaoDimensoes",
      label: "Data Atualização Dimensões Principais",
      format: formatDetailDate,
    },
    { key: "comprimentoConves", label: "Comprimento do Convés (m)" },
    { key: "larguraConves", label: "Largura do Convés (m)" },
    { key: "areaTotalConves", label: "Área total do Convés (m²)" },
    { key: "resistenciaConves", label: "Resistência do Convés (T/m²)" },
    { key: "capacidadeConves", label: "Capacidade do Convés (T)" },
    { key: "comprimentoConvesLivreUtil", label: "Comprimento do Convés Livre Útil (m)" },
    { key: "larguraConvesLivreUtil", label: "Largura do Convés Livre Útil (m)" },
    { key: "areaConvesLivreUtil", label: "Área do Convés Livre Útil (m²)" },
    { key: "atualizacaoCargoDeck", label: "Data Atualização Cargo Deck", format: formatDetailDate },
    { key: "deslocamentoCaladoDocagem", label: "Deslocamento calado docagem [T]" },
    { key: "caladoHidrostaticoDocagem", label: "Calado hidrostático de docagem [m]" },
    { key: "tamanhoApendices", label: "Tamanho dos apêndices [m]" },
    { key: "equipamentoRetratil", label: "Equipamento retrátil" },
    { key: "caladoRealDocagem", label: "Calado real de docagem [m]" },
    { key: "atualizacaoDocagem", label: "Data Atualização Docagem", format: formatDetailDate },
  ];
